import React from "preact";

interface MOBackIconProps {
  onClick?: () => void;
  className?: string;
}

function MOBackIcon({onClick, className}: MOBackIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 19 19" onClick={onClick}>
      <path fill="#333" d="M14.25 3.272v-1.64a.17.17 0 00-.274-.133L4.418 8.965a.676.676 0 000 1.067l9.56 7.466a.169.169 0 00.273-.133v-1.64a.343.343 0 00-.13-.267L6.488 9.5l7.634-5.961a.343.343 0 00.129-.268z"></path>
    </svg>
  );
}

export default MOBackIcon;
